'use strict';

const hyresgaster = {
    initSokFastighetFelanmalan: function (sokform, sokinput, sokresultdiv) {
        const links = Array.from(document.querySelectorAll('.container-hyresgaster .row-fastighetsindex .js-fetch-anslagstavla'));

        sokinput.addEventListener('input', function () {
            const query = this.value || null;

            af.removeAllChildNodes(sokresultdiv);
            sokinput.classList.remove('active');
            sokinput.classList.remove('expanded');

            if (query !== null && query.length > 0) {
                sokinput.classList.add('active');
            }

            if (query !== null && query.length > 1) {
                const lankar = hyresgaster.autocomplete(query, links);

                lankar.forEach(el => {
                    const div = document.createElement('div');
                    div.setAttribute('data-address-result', el.isAddressResult);
                    const lank = el.cloneNode(true);
                    lank.innerHTML = el.matchResult;
                    lank.title = '';
                    lank.setAttribute('data-address-result', el.isAddressResult);
                    div.appendChild(lank);
                    sokresultdiv.appendChild(div);
                    sokinput.classList.add('expanded');
                });
            }
        });

        sokform.addEventListener('submit', function (e) {
            e.preventDefault();
        });
    },

    initSokFastighet: function (sokform, sokinput, sokresultdiv) {
        const links = Array.from(document.querySelectorAll('.container-hyresgaster .row-fastighetsindex .js-fetch-anslagstavla'));

        sokinput.addEventListener('input', function () {
            const query = this.value || null;

            af.removeAllChildNodes(sokresultdiv);
            sokinput.classList.remove('active');
            sokinput.classList.remove('expanded');

            if (query !== null && query.length > 0) {
                sokinput.classList.add('active');
            }

            if (query !== null && query.length > 1) {
                const lankar = hyresgaster.autocomplete(query, links);

                lankar.forEach(el => {
                    const div = document.createElement('div');
                    div.setAttribute('data-address-result', el.isAddressResult);
                    const lank = el.cloneNode(true);
                    lank.innerHTML = el.matchResult;
                    lank.setAttribute('data-address-result', el.isAddressResult);
                    div.appendChild(lank);
                    sokresultdiv.appendChild(div);
                    sokinput.classList.add('expanded');
                });
            }
        });

        sokform.addEventListener('submit', function (e) {
            e.preventDefault();
        });
    },

    autocomplete: function(val, links) {
        const resultat = links.filter(link => {
            const namn = link.textContent;
            const adress = link.getAttribute('data-adress') || '';
            const konceptnamn = link.getAttribute('data-konceptnamn') || '';
            const fastighetsbeteckning = link.getAttribute('data-fastighetsbeteckning') || '';
            const omrade = link.getAttribute('data-omrade');
            const epostadress = link.getAttribute('data-mejladress');
            const extraText = link.getAttribute('data-extratext');

            if (epostadress == '' && extraText == '') {
                link.matchResult = namn + hyresgaster.laggTillOmrade(omrade);
                link.isAddressResult = false;
                return false;
            }

            if (hyresgaster.isMatch(namn, val)) {
                link.matchResult = namn + hyresgaster.laggTillOmrade(omrade);
                link.isAddressResult = false;
                return true;
            }

            if (hyresgaster.isMatch(konceptnamn, val)) {
                link.matchResult = konceptnamn + hyresgaster.laggTillOmrade(omrade);
                link.isAddressResult = false;
                return true;
            }

            if (hyresgaster.isMatch(fastighetsbeteckning, val)) {
                link.matchResult = fastighetsbeteckning + hyresgaster.laggTillOmrade(omrade);
                link.isAddressResult = false;
                return true;
            }

            if (hyresgaster.isMatch(adress, val)) {
                link.matchResult = adress + hyresgaster.laggTillOmrade(omrade);
                link.isAddressResult = true;
                return true;
            }

            return false;
        });

        var distinctResult = resultat.filter(function({ matchResult }) { return !this.has(matchResult) && this.add(matchResult); }, new Set);

        return distinctResult;
    },

    laggTillOmrade: function (omrade) {
        if (omrade) {
            return ', ' + omrade + '';
        }

        return '';
    },

    isMatch: function (item, val) {
        return item.substr(0, val.length).toLowerCase() === val.toLowerCase();
    },
};

(function () {
    const hg = document.getElementById('livlina-hyresgaster');
    const index = document.getElementById('hyresgasterIndex');
    const anslagstavla = document.getElementById('anslagstavla');
    const reklam = document.getElementById('anslagstavla-reklam');
    const anslagstavlaContainer = document.querySelector('#anslagstavla .container-hyresgaster');
    const hgtoggler = document.getElementById('navbar-toggler-hyresgaster');
    const sokinput = document.getElementById('sok-fastighet');
    const sokresultdiv = document.getElementById('sok-traffar');
    const sokform = document.getElementById('sok-fastighet-form');

    if (hg) {
        hanteraAnkare();
        hanteraPrivatBostadModal();
        hanteraHGMenyUtfalld();
        hyresgaster.initSokFastighet(sokform, sokinput, sokresultdiv);
    }

    function hanteraAnkare() {
        hg.addEventListener('click', function (e) {
            if (e.target.nodeName === 'A') {
                const link = e.target;

                if (af.isLocalBookmark(link)) {
                    const current = document.querySelector('.hyresgaster-inner.active');
                    const next = document.querySelector(link.hash);
                    const currentOrder = current.getAttribute('data-order');
                    const nextOrder = next.getAttribute('data-order');
                    const currentClass = (currentOrder < nextOrder) ? 'prev' : 'next';
                    const nextClass = (nextOrder > currentOrder) ? 'next' : 'prev';

                    e.preventDefault();
                    sokinput.blur();

                    hamtaAnslagstavla(link);
                    hanteraSokLankar(link);

                    next.scrollTo({ top: 0, behavior: 'smooth' });

                    uppdateraKlasser(current, currentClass);
                    uppdateraKlasser(next, nextClass, true);
                }
            }
        });
    }


    function stangPrivatBostadModal() {
        $('#privat-bostad-modal-hyres').modal('hide');
    }

    function hanteraPrivatBostadModal() {
        const modalGaVidare = document.getElementById('privat-felanmalan-fastighet-ga-vidare');
        const modalStang = document.getElementById('privat-felanmalan-fastighet-stang');
        modalGaVidare.addEventListener('click', stangPrivatBostadModal);
        modalStang.addEventListener('click', stangPrivatBostadModal);
    }

    function hamtaAnslagstavla(link) {
        const dataId = link.getAttribute('data-fastighet-id');
        const fastighetsbeteckning = link.getAttribute('data-fastighetsbeteckning');

        if (dataId) {
            var url = document.getElementById('url-anslagstavla').value;

            fetch(url + '?fastighetId=' + dataId + '&fastighetsbeteckning=' + fastighetsbeteckning)
                .then(response => response.text())
                .then(result => {
                    anslagstavlaContainer.innerHTML = result;


                    const el = document.querySelector('#multifile-livlinanformular [data-fn-trigger="multifile"]');
                    AlectaFastigheter.CustomMultifile.init(el);

                    const elList = document.querySelectorAll('.form-multifile--list');
                    if (elList) {
                        [...elList].forEach((item) => {
                            item.addEventListener('click', e => {
                                if (e.target.matches('button')) {
                                    const MAX_FILE_SIZE = AlectaFastigheter.CustomMultifile.getMaxFileSize();
                                    const totalFileSize = (AlectaFastigheter.CustomMultifile.sumFileSizes(AlectaFastigheter.CustomMultifile.uploadedFiles) / 1024);

                                    if (totalFileSize <= MAX_FILE_SIZE) {
                                        window.doljFilerFelmeddelande();
                                    }
                                }
                            })
                        })
                    }

                    hamtaReklam();
                    hanteraSmartaLankar();
                    hanteraPrivatBostad();
                });
        }
    }

    function hamtaReklam() {
        const reklamPuff = document.querySelector('#anslagstavla #reklam-container');
        const reklamSida = document.querySelector('#anslagstavla-reklam .container-hyresgaster');
        if (reklamPuff && reklamSida) {
            reklamSida.innerHTML = reklamPuff.innerHTML;
        }
    }

    function hanteraSmartaLankar() {
        const smartalankar = document.querySelectorAll('.anslagstavla-snabblankar a, .anslagstavla-fakta a');

        smartalankar.forEach(lank => {
            lank.addEventListener('click', (e) => {
                const hash = lank.hash.slice(1);
                if (hash.length) {
                    e.preventDefault();
                    hgtoggler.click();
                    af.removeScrollPosition(lank.pathname);
                    if (lank.pathname === location.pathname) {
                        const element = document.getElementById(hash);
                        if (element) {
                            af.scrollToElement(element, lank.hash);
                        }
                    } else {
                        sessionStorage.setItem('hash', hash);
                        location.href = lank.href.split('#')[0];
                    }
                }
            });
        });
    }

    function hanteraSokLankar(link) {
        if (link.parentNode.id === 'sok-traffar') {
            sokinput.value = '';
            af.removeAllChildNodes(sokresultdiv);
        }
    }

    function uppdateraKlasser(el, klass, aktiv = false) {
        el.classList.remove('prev', 'next', 'active');
        el.classList.add(klass);
        if (aktiv) {
            el.classList.add('active');
        }
    }

    function hanteraHGMenyUtfalld() {

        $('#livlina-hyresgaster').on('show.bs.collapse', function () {
            index.classList.remove('prev', 'next', 'active');
            anslagstavla.classList.remove('prev', 'next', 'active');
            reklam.classList.remove('prev', 'next', 'active');

            index.classList.add('active');
            anslagstavla.classList.add('next');
            reklam.classList.add('next');

            setTimeout(function () {
                index.scrollTo({ top: 0, behavior: 'smooth' });
            }, 100);

        });
    }

    function hanteraAdressDropDown(event) {
        var adressSelect = event.target;
        var option = adressSelect.options[adressSelect.selectedIndex];
        if ((option.value != '')) {

            doljFelmeddelandeValdAdress();
            if (option.dataset.arBostadsadress == 'True') {
                const link = document.getElementById('Formular_ExternFelanmalanUrl').value;
                console.log(document.getElementById('Formular_ExternFelanmalanUrl'));
                const faqelement = document.getElementById('fastighet-faq-link');
                faqelement.href = link;
                $('#privat-bostad-modal-hyres').modal('show');
            }
        }
    }

    function hanteraPrivatBostad() {
        const adressSelect = document.getElementById('Formular_ValdAdress');
        if (adressSelect.tagName.toLowerCase() != 'input') {
            adressSelect.addEventListener('change', hanteraAdressDropDown);
        }
    }
})();
